import { OpaqueToken } from '@angular/core';

export const AUTH_CONFIG = new OpaqueToken('AuthConfig');



// WEBPACK FOOTER //
// ./src/app/@shared/auth/auth.config.ts